import { users } from './users/'
import { roles } from './roles/'
import { wallets } from './wallets/'

import { transactions } from './transactions/'
import { bonus } from './bonus/'
import { reports } from './reports/'

import { auth } from './auth/'
import { playerCard } from './player-card'
import { contributions } from './contributions'

import { sportsROCalculator } from './sports-ro-calculator'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  HOME: '/',
  error: '/404',
  auth,
  roles,
  users,
  wallets,
  transactions,
  bonus,
  reports,
  playerCard,
  contributions,
  sportsROCalculator,
}
